import { BillingModality } from '@synergy/models';
import { Box, Stack } from '@mui/material';
import {
    CheckSuccess,
    PoolButton,
    PoolModal,
    PoolModalActions,
    PoolModalContent,
    PoolTypography,
} from '@synergy/components-next';
import { FormattedMessage } from 'react-intl';
import { PoolFormattedMessage } from '@synergy/components-next';
import { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from '../../../sidebar-menu/navigation-drawer/routes';
import { bonusSettlementDetailSelector } from '../store/bonus-settlements-detail-selector';
import { resetSubmittedSuccessModal } from '../store/bonus-settlements-detail-actions';
import { useAppDispatch, useAppSelector } from '../../../../store/store';

interface BonusSettlementDetailSubmitSuccessModalProps {
    open: boolean;
    onClose: () => void;
}

export const BonusSettlementDetailSubmitSuccessModal = (
    props: BonusSettlementDetailSubmitSuccessModalProps
): ReactElement => {
    const { open, onClose } = props;
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const bonusSettlementDetail = useAppSelector(bonusSettlementDetailSelector);

    const handleNavigate = () => {
        onClose();
        navigate(ROUTES.bonusSettlements.overview);
        dispatch(resetSubmittedSuccessModal());
    };

    return (
        <PoolModal open={open}>
            <PoolModalContent>
                <Stack alignItems="center" gap={2}>
                    <Box sx={{ width: 130 }}>
                        <CheckSuccess />
                    </Box>

                    <Stack gap={1.5}>
                        <PoolTypography
                            variant="h5"
                            translationId="app.bonusSettlements.supplierDetail.submitSuccessModalTitle"
                        />
                        <PoolFormattedMessage
                            id={
                                bonusSettlementDetail?.billingModality === BillingModality.Invoice
                                    ? 'app.bonusSettlements.supplierDetail.submitSuccessModalContentInvoice'
                                    : 'app.bonusSettlements.supplierDetail.submitSuccessModalContentCredit'
                            }
                            values={{ year: bonusSettlementDetail?.year }}
                        />
                    </Stack>
                </Stack>
            </PoolModalContent>
            <PoolModalActions sx={{ justifyContent: 'center' }}>
                <PoolButton onClick={handleNavigate}>
                    <FormattedMessage id="app.bonusSettlements.supplierDetail.submitSuccessModalClose" />
                </PoolButton>
            </PoolModalActions>
        </PoolModal>
    );
};
